export const DISCOUNT_CAP_MESSAGE =
  'Discount cannot reduce the order total below $1.'

export const MAX_DISCOUNT_PERCENT = 100

export const PROMO_CODE_PATTERN = /^[0-9a-zA-Z]{0,15}$/

export const getCodeValidationError = (value) => {
  if (value === '' || value === undefined || value === null) return null

  if (PROMO_CODE_PATTERN.test(String(value))) return null

  return { field: 'code' }
}

export const getDiscountValidationError = (value, priceOption, priceOpts) => {
  if (value === '' || value === undefined || value === null) return null

  const numeric = parseFloat(value)
  if (!Number.isFinite(numeric)) return null

  if (priceOption === priceOpts[1]?.value && numeric >= MAX_DISCOUNT_PERCENT) {
    return { field: 'discount' }
  }

  return null
}
